import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UserDTO } from './user.model';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Role } from '../user/role.model'; // Ensure Role interface or type is imported
import { Department } from '../user/department.model';
import { UserListComponent } from '../user-list/user-list.component';
import { IdName } from '../../dtos/IdName';
import { RoleEnum, RoleNameEnum } from '../../enums/role.enum';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  standalone: false
})
export class UserComponent implements OnInit {
  @ViewChild(UserListComponent) userListCompo: any;
  displayedColumns: string[] = [
    'firstName',
    'lastName',
    'userName',
    'contact',
    'email',
    'department',
    'employeeCode',
    'joiningDate',
    'birthDate',
    'role',
    'employeeType'
  ];
  userData: UserDTO[] = [];
  userForm: FormGroup;
  isSubmitting: boolean = false;
  submitSuccess: boolean = false;
  submitError: string = '';
  roles: Role[] = []; // Ensure Role interface or type is used
  departments: Department[] = [];
  nteamleads: IdName[] = [];
  filteredTeamleads: IdName[] = [];
  selectedRole: string = '';
  employeeTypes = [
    // { id: 0, employeeType: 'ADMIN' },
    { id: 1, employeeType: 'EMPLOYEE' },
    { id: 2, employeeType: 'MERIL CONSULTANT' },
    { id: 3, employeeType: 'PRIME CONSULTANT' },
    { id: 4, employeeType: 'EXTERNAL'}
  ];
  usersJsonData:any
  isAdmin: boolean = false;
  defaultDepartment: string = 'OPERATIONS';
  isTeamlead: boolean = false;
  isDepartmentAdmin: boolean = false;


  roleNameEnum: typeof RoleNameEnum = RoleNameEnum;

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.userForm = this.fb.group({
      userName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.required],
      contact: [''],
      departmentId: ['', Validators.required],
      employeeCode: [''],
      joiningDate: ['',Validators.required],
      birthDate: [''],
      role: ['', Validators.required], // Use FormControl for role
      teamleads: [[], ],
      employeeType: ['', Validators.required]
      
       
    },
  {
    validators: this.dateValidator()
  });
 
  }

  ngOnInit(): void {
    this.getStorageData()
    this.getRoles(); // Fetch roles on component initialization
    this.getDepartments(); // Fetch departments on component initialization
    this.setDeptValueForDeptAdmin();
    this.getAllUsers(); // Fetch users on component initialization
    // this.getTeamleads();
  }

  getStorageData(){
    let user:any = sessionStorage.getItem("userData")
    this.usersJsonData = JSON.parse(user);
    this.isAdmin = this.usersJsonData.roleId == RoleEnum.ADMIN;
    this.isTeamlead = this.usersJsonData.roleId == RoleEnum.TEAMLEAD;
    this.isDepartmentAdmin = this.usersJsonData.roleId == RoleEnum.DEPARTMENT_ADMIN;
  }

  getRoles(): void {
    this.userService.getRoles().subscribe(
      (responseObject: any) => {
        this.roles = responseObject.map((role: any) => ({ id: role.id, role: role.role }));
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getTeamleadsByDepartment(departmentId: number): void {
    if (!departmentId) {
      this.filteredTeamleads = [];
      return;
    }

    this.userService.getTeamleadsByDepartment(departmentId).subscribe(
      (res: any) => {
        this.filteredTeamleads = res;
      },
      (error: any) => {
        this.snackBar.open('Error fetching team leads', 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
        });
      }
    );
  }

  getDepartments(): void {
    this.userService.getDepartments().subscribe(
      (responseObject: Department[]) => {
        this.departments = responseObject.map((department: Department) => ({ id: department.id, departmentName: department.departmentName }));
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  getEmployeeTypeName(employeeTypeId: number): string | undefined {
    const employeeType = this.employeeTypes.find(et => et.id === employeeTypeId);
    return employeeType ? employeeType.employeeType : undefined;
  }

  getEmployeeTypeId(employeeTypeName: string): number | undefined {
    const employeeType = this.employeeTypes.find(et => et.employeeType === employeeTypeName);
    return employeeType ? employeeType.id : undefined;
  }

  getAllUsers(): void {
    this.userService.getAllUsers(this.usersJsonData.id, 1, 10).subscribe(
      (res: any) => {
        if (res && res.responseObject && res.responseObject.responseData) {
          if (Array.isArray(res.responseObject.responseData)) {
            this.userData = res.responseObject.responseData.map((user: UserDTO) => ({
             ...user,
              role: this.getRoleName(user.roleId),
              department: this.getDepartmentName(user.departmentId)
            }));
          }
        } else {
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }
  
  getTeamleadName(id: number): string | undefined {
    const tlName = this.nteamleads.find(t => t.id === id)
    return tlName ? tlName.name: undefined;
  }


  onDepartmentChange(departmentId: number) {
    // let departmentId = this.departments.find(dep => dep.departmentName === departmentName)?.id ?? null;

    if (departmentId) {
      this.userService.getTeamleadsByDepartment(departmentId).subscribe(
        (res: IdName[]) => {
          this.filteredTeamleads = res;
        },
        (error: any) => {
          this.filteredTeamleads = [];
        }
      );
    } else {
      this.filteredTeamleads = []; // Clear dropdown if no department is selected
    }
    this.userForm.get('role')?.setValue('');
    this.selectedRole = ''; //clear selected role variable
    this.userForm.get('teamleads')?.setValue([]);
  }
  
  getRoleName(roleId: number): string | undefined {
    const role = this.roles.find(r => r.id === roleId);
    return role ? role.role : undefined;
  }


  getDepartmentName(departmentId: number): string | undefined {
    if (!this.departments) {
      return undefined;
    }
    const department = this.departments.find(d => d.id === departmentId);
    return department ? department.departmentName : undefined;
  }

 onSave(): void {
  if (this.userForm.valid) {

    const formValue = this.userForm.getRawValue();

    const userData = {
      ...formValue,
      roleId: this.getRoleId(formValue.role),
      employeeTypeId: this.getEmployeeTypeId(formValue.employeeType)
    };

    this.userService.create(userData).subscribe(
      (res: any) => {

        this.isSubmitting = false;

        const message = res.message?.toLowerCase() || '';

        const isDuplicate =
          message.includes('username') ||
          message.includes('email') ||
          message.includes('employee code');

        if (isDuplicate) {
        
          this.submitSuccess = false;

          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });

          return;
        }

        this.submitSuccess = true;

        this.userData.push(res.responseObject);

        this.userListCompo.getAllUserForFilter();
        this.userListCompo.getAllUsers(
          this.userListCompo.currentPage,
          this.userListCompo.pageSize
        );

        this.snackBar.open(res.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });

        this.clearFormData();
      },

      (error: any) => {
        this.isSubmitting = false;
        this.submitSuccess = false;
        this.submitError = 'Error submitting form';
        this.clearFormData();

        this.snackBar.open(`Error submitting form: ${error.message}`, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );

  } else {

    this.submitSuccess = false;
    this.submitError = 'Form is invalid. Please check all fields.';

    this.snackBar.open('Form is invalid. Please check all fields.', 'Close', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });

    this.userForm.markAllAsTouched();
  }
}
  
  getRoleId(roleName: string): number | undefined {
    const role = this.roles.find(r => r.role === roleName);
    return role ? role.id : undefined;
  }

  getDepartmentId(departmentName: string): number | undefined {
    const department = this.departments.find(d => d.departmentName === departmentName);
    return department ? department.id : undefined;
  }

  clearFormData(){
    this.userForm.reset()
    Object.keys(this.userForm.controls).forEach(key => {
      this.userForm.get(key)?.setErrors(null);
    });
    this.userForm.markAsPristine()
    this.userForm.markAsUntouched()
    this.userForm.updateValueAndValidity()
    // this.userForm.
    this.setDeptValueForDeptAdmin();
    this.selectedRole = '';
    this.userForm.get('departmentId')?.setValue(null);
    this.userForm.get('departmentId')?.enable();
    this.userForm.get('departmentId')?.addValidators(Validators.required);
    this.userForm.get('departmentId')?.updateValueAndValidity();
  }

  onRoleChange(event: any) {
    this.selectedRole = event.value;
  
    if (this.selectedRole === 'EMPLOYEE' || this.selectedRole === 'TEAMLEAD') {
      
    }
    else if (this.selectedRole === RoleNameEnum.ADMIN) {
      this.userForm.get('departmentId')?.setValue(null);
      this.userForm.get('departmentId')?.disable();
      this.userForm.get('departmentId')?.clearValidators();
      this.userForm.get('departmentId')?.updateValueAndValidity();
    }
    else {
      this.userForm.get('teamleadIds')?.setValue([]); // Clear selection
    }
  }

  setDeptValueForDeptAdmin(): void {
    if(this.isDepartmentAdmin) {
      this.userForm.patchValue({departmentId: this.usersJsonData.departmentId});
      this.userForm.get('departmentId')?.disable();
      this.onDepartmentChange(this.usersJsonData.departmentId);
    }
  }

  onlyText(event: KeyboardEvent) {
  const char = event.key;

  // Allow letters + space
  if (!/^[a-zA-Z\s]$/.test(char)) {
    event.preventDefault();
  }
}

checkDateValidation() {

  const dob = this.userForm.get('birthDate')?.value;
  const joining = this.userForm.get('joiningDate')?.value;

  if (!dob || !joining) return;

  const dobDate = new Date(dob);
  const joiningDate = new Date(joining);

  const birthControl = this.userForm.get('birthDate');

  if (dobDate > joiningDate) {
    birthControl?.setErrors({ invalidDOB: true });
  } else {
    const errors = birthControl?.errors;

    if (errors) {
      delete errors['invalidDOB'];

      if (Object.keys(errors).length === 0) {
        birthControl.setErrors(null);
      } else {
        birthControl.setErrors(errors);
      }
    }
  }
}


isValidEmail(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  return emailRegex.test(email);
}
checkEmail() {
  const email = this.userForm.get('email')?.value;

  if (email && !this.isValidEmail(email)) {
    this.userForm.get('email')?.setErrors({ invalidEmail: true });
  }
}


dateValidator(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {

    const dobControl = form.get('birthDate');
    const joiningControl = form.get('joiningDate');

    const dob = dobControl?.value;
    const joining = joiningControl?.value;

    if (!dob || !joining) return null;

    const dobDate = new Date(dob);
    const joiningDate = new Date(joining);
 
    joiningControl?.setErrors(null);
    dobControl?.setErrors(null);

    if (dobDate > joiningDate) {
      dobControl?.setErrors({ invalidDOB: true });
      return { invalidDOB: true };
    }

    let age = joiningDate.getFullYear() - dobDate.getFullYear();
    const m = joiningDate.getMonth() - dobDate.getMonth();

    if (m < 0 || (m === 0 && joiningDate.getDate() < dobDate.getDate())) {
      age--;
    }

    if (age < 18) {
      joiningControl?.setErrors({ ageInvalid: true });
      return { ageInvalid: true };
    }

    return null;
  };
}
}
